import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'
import { routes } from 'config'
import { constants, isMultiLoginApp } from 'utils'
import {
  Module,
  ModuleHeader,
  ModuleBody,
  CustomAlert,
  CustomButton,
  ButtonContainer,
} from 'components'

interface IProps {
  transaction: any
  serviceError: string
}

const EmailSentConfirmation: FC<IProps> = ({ transaction, serviceError }) => {
  const navigate = useNavigate()

  const titleForgotLoginConfimation = isMultiLoginApp()
    ? 'Check your email finish setting up'
    : "You're all set!"

  const descriptionForgotLoginAlert = isMultiLoginApp()
    ? `We've sent a secure link to the email associated with the account so you can create
    your multi login password`
    : `If you are a Bright MLS subscriber, an email with password reset
    instructions has been sent to the email address associated with that login name.`

  const descriptionForgotLoginBody = isMultiLoginApp() ? (
    <Typography variant="body1">
      Once complete, you'll be able to link and switch between your office
      accounts without logging out
    </Typography>
  ) : (
    <Typography variant="body1">
      The email was sent from{' '}
      <strong className="no-wrap">{constants.NO_REPLY_EMAIL_OKTA}</strong>. If
      that email does not arrive soon, please check your spam folder.
    </Typography>
  )

  const customForgotLoginButtomTag = isMultiLoginApp() ? (
    <CustomButton
      style={{ fontSize: '1rem' }}
      onClick={() => navigate(routes.multiLogin)}
    >
      Return To Subscription Page
    </CustomButton>
  ) : (
    <CustomButton onClick={() => navigate(routes.login)}>
      Return To Login
    </CustomButton>
  )

  return (
    <Module>
      <ModuleHeader title={titleForgotLoginConfimation}>
        <CustomAlert severity="success" title="Success!">
          {descriptionForgotLoginAlert}
        </CustomAlert>
        <CustomAlert severity="error">{serviceError}</CustomAlert>
      </ModuleHeader>

      <ModuleBody>
        {descriptionForgotLoginBody}

        <ButtonContainer
          primary={customForgotLoginButtomTag}
          secondary={<div />}
        />
      </ModuleBody>
    </Module>
  )
}

export default EmailSentConfirmation
